import { getSrc } from 'components/elements/PictureHelper';
import { useEffect, useState } from 'react';

function Picture(props) {
    const [imgSrc, setImgSrc] = useState(null);
    const [mobImgSrc, setMobImgSrc] = useState(null);
    
    useEffect(() => {
        if(!imgSrc && props?.img) {
            setImgSrc(getSrc(props.img));
        }
        if(!mobImgSrc && props?.img_mob) {
            setMobImgSrc(getSrc(props.img_mob));
        }
    }, [])

    if (props?.img?.source && (!props.img_mob || !props.img_mob.source)) return (
        <img
            data-test-id={props.dti + "-d"}
            alt={props?.img?.alt}
            src={imgSrc}
            title={props?.img?.title}
            className={"text-white w-100 " + props.className ? props.className : ''} />
    )

    if ((!props.img || !props.img.source) && props?.img_mob?.source) return (
        <img
            data-test-id={props.dti + "-m"}
            alt={props?.img_mob?.alt}
            src={mobImgSrc}
            title={props?.img_mob?.title}
            className={"text-white w-100 " + props.className ? props.className : ''} />
    )

    if (props.img && props.img.source && props.img_mob && props.img_mob.source) return (
        <picture style={{ width: '100%' }} className={props.className ? props.className : ''}>
            <source media="(max-width:767px)" srcSet={mobImgSrc} data-test-id={props.dti + "-m"} />
            <img src={imgSrc} className="text-white w-100" data-test-id={props.dti + "-d"}
                alt={props.img.alt ? props.img.alt : false} title={props?.img?.title} />
        </picture>
    )

    return null
}

export default Picture;
